<div class="compare-job-offer-cv-container-loading" *ngIf="loading_analysis">
    <img src="assets/spinner.gif" alt="Loading" width="64" height="64" />
</div>
<div class="compare-job-offer-cv-container-content" *ngIf="!loading_analysis">
    <div class="compare-job-offer-cv-container" *ngFor="let analysis of data_analysis | keyvalue">

        <div class="compare-job-offer-cv-container-header">
            <h2 class="compare-job-offer-cv-container-title">{{ 'CVDeepAnalyzer.compareCVJobOffer.titleGeneralInformation' | translate }}</h2>
        </div>


        <div class="cv-upload-files-container-information">
            <div class="cv-upload-files-container-information-item">
                <h4><strong>{{ 'CVDeepAnalyzer.compareCVJobOffer.job_description' | translate }}</strong></h4>
                <p>{{ data_job_offers[analysis.key]?.job_description }}</p> 
            </div>
            <div class="cv-upload-files-container-information-item" *ngIf="data_job_offers[analysis.key]?.languages && data_job_offers[analysis.key]?.languages.length > 0">
                <h4><strong>{{ 'CVDeepAnalyzer.compareCVJobOffer.languages' | translate }}</strong></h4>
                <div class="cv-upload-files-container-information-item-languages">
                    <div *ngFor="let language of data_job_offers[analysis.key]?.languages" class="cv-upload-files-container-information-item-languages-item">
                        <img src="assets/extension-chrome/country-flags/{{ (language?.language === 'en' ? 'gb' : language?.language) | lowercase }}.svg" alt="Language">
                        <span>{{ ('CVDeepAnalyzer.compareCVJobOffer.languageLevel.' + (language.level | lowercase)) | translate }}</span>
                    </div>
                </div>
                <p *ngIf="!data_job_offers[analysis.key]?.languages">N/A</p> 
            </div>
            <div class="cv-upload-files-container-information-item" *ngIf="data_job_offers[analysis.key]?.skills_tools && data_job_offers[analysis.key]?.skills_tools.length > 0">
                <h4><strong>{{ 'CVDeepAnalyzer.compareCVJobOffer.skills_tools' | translate }}</strong></h4>
                <div class="cv-upload-files-container-information-item-skills-tools">
                    <div *ngFor="let skill of data_job_offers[analysis.key]?.skills_tools">{{ skill }}</div>
                </div>
                <p *ngIf="!data_job_offers[analysis.key]?.skills_tools">N/A</p> 
            </div>
            <div class="cv-upload-files-container-information-item" *ngIf="data_job_offers[analysis.key]?.location">
                <h4><strong>{{ 'CVDeepAnalyzer.compareCVJobOffer.location' | translate }}</strong></h4>
                <p *ngIf="data_job_offers[analysis.key]?.location">{{ data_job_offers[analysis.key]?.location }}</p> 
                <p *ngIf="!data_job_offers[analysis.key]?.location">N/A</p> 
            </div>
            <div class="cv-upload-files-container-information-item">
                <h4><strong>{{ 'CVDeepAnalyzer.compareCVJobOffer.yearsOfExperienceRequired' | translate }}</strong></h4>
                <p *ngIf="data_job_offers[analysis.key]?.years_of_experience_required">{{ data_job_offers[analysis.key]?.years_of_experience_required }}</p> 
                <p *ngIf="!data_job_offers[analysis.key]?.years_of_experience_required">N/A</p> 
            </div>
        </div>

        <div class="compare-job-offer-cv-container-header">
            <h2 class="compare-job-offer-cv-container-title">{{ 'CVDeepAnalyzer.compareCVJobOffer.title' | translate }}</h2>
        </div>

        <div class="cv-upload-files-container-actions">
            <div class="cv-upload-files-container-actions">
                <div class="cv-upload-files-container-actions-left">
                    <div class="cv-upload-files-container-actions-left-item">
                        <span>{{ 'CVDeepAnalyzer.compareCVJobOffer.totalCVs' | translate }}</span>
                        <strong>{{ total_CVs }}</strong>
                    </div>
                    <div class="cv-upload-files-container-actions-left-item">
                        <span>{{ 'CVDeepAnalyzer.compareCVJobOffer.JobOffers' | translate }}</span>
                        <strong>{{ analysis.key }}</strong> 
                    </div>
                </div>
            </div>
            <div class="cv-upload-files-container-actions-left">
                <div class="dropdown-container">
                    <button class="conectio-rectangular-small-add" color="primary" type="button" (click)="togglePreferencesPanel()" [attr.aria-expanded]="showPreferencesPanel" [ngClass]="{'selected-button': !showPreferencesPanel}">
                        <img src="assets/Deep-CV/Compare/setting-numbers.png" *ngIf="showPreferencesPanel" alt="Preference settings" class="img-small">
                        <img src="assets/Deep-CV/Compare/setting-numbers-purple.png" *ngIf="!showPreferencesPanel" alt="Preference settings" class="img-small">
                    </button>
                
                    <div class="preferences-dropdown" *ngIf="showPreferencesPanel">
                        <h3>{{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfiltersTitle' | translate }}</h3>
                        <div class="preference-row">
                            <label class="preference-label">
                                {{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfilters.experience_score' | translate }}:
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    [attr.aria-label]="'experience_score'"
                                    [attr.title]="'experience_score'"
                                    [value]="preferences['experience_score']"
                                    (input)="updatePreferenceValue('experience_score', $event)"
                                />
                            </label>
                        </div>
                        <div class="preference-row" *ngIf="data_job_offers[analysis.key]?.skills_tools && data_job_offers[analysis.key]?.skills_tools.length > 0">
                            <label class="preference-label">
                                {{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfilters.skills_score' | translate }}:
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    [attr.aria-label]="'skills_score'"
                                    [attr.title]="'skills_score'"
                                    [value]="preferences['skills_score']"
                                    (input)="updatePreferenceValue('skills_score', $event)"
                                />
                            </label>
                        </div>
                        <div class="preference-row" *ngIf="data_job_offers[analysis.key]?.languages && data_job_offers[analysis.key]?.languages.length > 0" >
                            <label class="preference-label">
                                {{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfilters.language_score' | translate }}:
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    [attr.aria-label]="'language_score'"
                                    [attr.title]="'language_score'"
                                    [value]="preferences['language_score']"
                                    (input)="updatePreferenceValue('language_score', $event)"
                                />
                            </label>
                        </div>
                        <div class="preference-row" *ngIf="data_job_offers[analysis.key]?.location">
                            <label class="preference-label">
                                <span>
                                    {{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfiltersMaxDistance' | translate }}:
                                    <b>{{ preferences['max_distance'] }} km</b>
                                </span>
                                <input
                                    type="range"
                                    min="0"
                                    max="1000"
                                    [attr.aria-label]="'CVDeepAnalyzer.compareCVJobOffer.preferencesTitle' | translate"
                                    [attr.title]="'CVDeepAnalyzer.compareCVJobOffer.preferencesTitle' | translate"
                                    [value]="preferences['max_distance']"
                                    (change)="setMaxDistance($event)"
                                />
                            </label>
                        </div>
                        <div class="preference-row" *ngIf="data_job_offers[analysis.key]?.languages && data_job_offers[analysis.key]?.languages.length > 0">
                            <label class="preference-label preference-required-language">
                                {{ 'CVDeepAnalyzer.compareCVJobOffer.preferencesfiltersLanguagesRequired' | translate }}:
                                <input
                                    type="checkbox"
                                    [attr.aria-label]="'CVDeepAnalyzer.compareCVJobOffer.preferencesTitle' | translate"
                                    [attr.title]="'CVDeepAnalyzer.compareCVJobOffer.preferencesTitle' | translate"
                                    [checked]="preferences['experience_score'] === 100"
                                    (change)="disableLanguagesRequired($event)"
                                />
                            </label>
                        </div>
                        <button mat-button class="apply-preference-button" color="primary" type="button" (click)="savePreferencesData()" [disabled]="loading_save_preferences">
                            <span *ngIf="!loading_save_preferences">{{ 'CVDeepAnalyzer.compareCVJobOffer.savePreferencesButton' | translate }}</span>
                            <span *ngIf="loading_save_preferences"><img src="assets/spinner.gif" alt="Loading" class="img-small"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-container">
            <ngx-datatable
            class='table table-hover' [rows]="analysis.value" [columnMode]="columnModeSetting"
                [rowHeight]="'auto'" [selected]="selected"
                [scrollbarH]="scrollBarHorizontal" ngSkipHydration>

                <div empty-content class="datatable-empty" *ngIf="profiles.length === 0">
                    <div class="container-empty-content">
                        <span>{{ 'CVDeepAnalyzer.compareCVJobOffer.noProfiles' | translate }}</span>
                    </div>
                </div>
                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.name' | translate" prop= "name" cellClass="d-flex align-items-center"  >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <span *ngIf="value">{{ value | titlecase}}</span>
                        <span *ngIf="!value">N/A</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.rol' | translate" prop= "actual_rol" cellClass="d-flex align-items-center"   >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                       <span *ngIf="value">{{ value | titlecase}}</span>
                       <span *ngIf="!value">N/A</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.C-score' | translate" prop= "cscore" cellClass="d-flex align-items-center" >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div *ngIf="value === 'not-identified'" class="aligned_div">
                            <img src="assets/spinner.gif" alt="Loading" class="img-small"  />
                            <span>( {{('CVDeepAnalyzer.compareCVJobOffer.status_updates.' + row.status) | translate}} )</span>
                        </div>
                        <span *ngIf="value !== 'not-identified'">{{ calculateCscore(row, analysis.key) }} %</span>
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.final_report' | translate" prop= "final_report" cellClass="d-flex align-items-center"   >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        {{ value }}

                        <a class="more-info-link" (click)="openModalMoreInfo(row)">{{ 'CVDeepAnalyzer.compareCVJobOffer.moreInfo' | translate }}</a>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.ubicación' | translate" prop= "location" cellClass="d-flex align-items-center"   >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <span *ngIf="value">{{ value | titlecase }} <span *ngIf="row.location_data?.distance?.text">({{ row.location_data?.distance?.text }})</span></span>
                        <span *ngIf="!value">N/A</span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [name]="'CVDeepAnalyzer.compareCVJobOffer.columns.acciones' | translate" cellClass="d-flex align-items-center"  >
                    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div class="table-actions">
                            <button type="button" *ngIf="row.phone"	 (click)="openGeneralModal({ title: 'Teléfono del candidato', message: 'El numero de telefono es: ' + row.phone, type: 'info'})" mat-icon-button title="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.phone' | translate }}"><img class="img-small" src="assets/Deep-CV/Compare/llamada-telefonica.png" alt="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.phone' | translate }}"></button>
                            <button type="button" *ngIf="row.email" (click)="openGeneralModal({ title: 'Correo electrónico del candidato', message: 'El correo electrónico es: ' + row.email, type: 'info'})" mat-icon-button title="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.email' | translate }}"><img class="img-small" src="assets/Deep-CV/Compare/correo-electronico.png" alt="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.email' | translate }}"></button>
                            <button type="button" *ngIf="row.linkedin_url" (click)="openLinkedin(row.linkedin_url)" mat-icon-button title="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.linkedin' | translate }}"><img class="img-small" src="assets/Deep-CV/Compare/linkedin.png" alt="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.linkedin' | translate }}"></button>
                            <button type="button" *ngIf="row.CV_url" (click)="openCV(row.CV_url)" mat-icon-button title="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.cv' | translate }}"><img class="img-small" src="assets/Deep-CV/Compare/cv.png" alt="{{ 'CVDeepAnalyzer.compareCVJobOffer.columns.cv' | translate }}"></button>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
    </div>
</div>